var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeatDetection = function SvgBeatDetection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.146 14.004a3.968 3.968 0 1 1 7.936 0 3.968 3.968 0 0 1-7.936 0m3.968-2.968a2.968 2.968 0 1 0 0 5.936 2.968 2.968 0 0 0 0-5.936M11.114 5.93a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3m-.15 1.15a.15.15 0 1 1 .3 0 .15.15 0 0 1-.3 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.679 4.738c0-1.233 1-2.234 2.234-2.234h10.403c1.234 0 2.234 1 2.234 2.234V18.61c0 1.233-1 2.233-2.234 2.233H5.913c-1.234 0-2.234-1-2.234-2.233zm2.234-1.234c-.682 0-1.234.553-1.234 1.234V18.61c0 .681.552 1.233 1.234 1.233h10.403c.681 0 1.234-.552 1.234-1.233V4.738c0-.681-.553-1.234-1.234-1.234z",
    clipRule: "evenodd"
  })));
};
export default SvgBeatDetection;